import React from 'react'
import { Router, Route, Redirect } from 'react-router-dom'
import history from './history'
import { ShopStore } from 'stores'
import { ShopContext } from 'stores/ShopStore'
import { App, Basket, Logout, Search, Login, ProductDetail, ThankYou, Unauthorized } from 'containers'
import { Authenticated, Unauthenticated } from 'components'

export const makeMainRoutes = () => {

    return (
        <ShopStore>
            <Router history={history}>
                <React.Fragment>
                    <Authenticated>
                        <Route path="/search" component={Search} />
                        <Route
                            path="/add/:id"
                            render={props => {
                                return (
                                    <ShopContext.Consumer>
                                        {(value: any) =>
                                            <ProductDetail
                                                {...props}
                                                basket={value.basket}
                                                addToBasket={value.addToBasket}
                                            />
                                        }
                                    </ ShopContext.Consumer>
                                )
                            }}
                        />
                        <Route
                            path="/basket"
                            render={props => {
                                return (
                                    <ShopContext.Consumer>
                                        {(value: any) =>
                                            <Basket
                                                {...props}
                                                items={value.basket}
                                                clearBasket={value.clearBasket}
                                            />
                                        }
                                    </ ShopContext.Consumer>
                                )
                            }}
                        />
                        <Route path="/logout" component={Logout} />
                        <Route path="/thankyou" component={ThankYou} />
                        <Redirect from="/" to="/search" />

                    </Authenticated>

                    <Route path="/login" component={Login} />
                    <Route path="/unauthorized" component={Unauthorized} />
                    <Route path="/" component={App} />

                    <Unauthenticated>
                        <Redirect to="/login" />
                    </Unauthenticated>

                </React.Fragment>
            </Router>
        </ShopStore>
  )
}



// WEBPACK FOOTER //
// ./src/routes.tsx